export default [
	'Masculino',
	'Feminino',
	'Homem transgênero',
	'Mulher Transgênero',
	'Homem Transexual',
	'Mulher Transexual',
	'Cisgênero',
	'Não sei responder',
	'Prefiro não responder',
	'Outros',
];
